import React from "react";
import FAQSection from '../components/FAQSection';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const CustomerServices = () => {
    return (
        <><Helmet>
            <title>Customer Service Solutions | MM AutoTech UK</title>
            <meta
                name="description"
                content="Enhance your garage’s customer service with MM AutoTech’s dedicated support solutions, ensuring client satisfaction and loyalty." />
            <link rel="canonical" href="https://mmautotech.com/services/customer-services" />
        </Helmet><div className="max-w-7xl mx-auto px-4 py-10 space-y-16">

                {/* ✅ Hero Section Part 1 - SaleGeneration style */}
                <section className="flex flex-col md:flex-row items-center gap-12">
                    <div className="md:w-1/2">
                        <h1 className="text-4xl font-bold mb-6 text-blue-900">Exceptional Support, Every Mile of the Way.</h1>
                        <p className="text-gray-700 mb-6">
                            At MM AutoTech, our Customer Care Services are designed to enhance the way garages connect with their clients. We manage customer inquiries, bookings, reminders, and follow-ups with professionalism and speed. With our dedicated team available 24/7, your garage delivers consistent service that builds trust and loyalty.
                        </p>
                        <Link to="/contact">
                            <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded shadow transition">
                                Book an Appointment
                            </button>
                        </Link>
                    </div>
                    <div className="md:w-1/2">
                        <img
                            src="/assets/customer.png"
                            alt="Car Sales"
                            className="rounded-lg shadow-lg object-cover w-full h-72 md:h-full" />
                    </div>
                </section>

                {/* ✅ Hero Section Part 2 - Original CustomerServices style */}
                <section className="text-blue-900 text-center">
                    <h2 className="text-3xl sm:text-4xl font-bold mb-2">Customer Care Services</h2>
                    <p className="text-blue-400 text-base sm:text-lg">
                        24/7 Customer Support, So You Never Miss a Job.
                    </p>
                </section>

                {/* ✅ Features Section */}
                <section>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
                        {/* Feature 1 */}
                        <div className="bg-white rounded-lg p-4 shadow hover:shadow-md transition">
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYhlKjoUuF-pxPH4JtNcLpSqBH3egDta2gkg&s"
                                alt="Friendly Staff"
                                className="w-full h-40 object-cover rounded mb-4" />
                            <h3 className="text-xl font-semibold mb-1">Friendly Support</h3>
                            <p className="text-gray-700 text-sm">
                                Our customer care team is ready to assist you with bookings, updates, and general help 24/7.
                            </p>
                        </div>

                        {/* Feature 2 */}
                        <div className="bg-white rounded-lg p-4 shadow hover:shadow-md transition">
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjcaiWQNHHg4zhdeO3wOjA1cz6J_W-WM5DWf7o_P3jaobdKsxLH_JyWgQlkNUWZgh7BAU&usqp=CAU"
                                alt="Upfront Pricing"
                                className="w-full h-40 object-cover rounded mb-4" />
                            <h3 className="text-xl font-semibold mb-1">Transparent Pricing</h3>
                            <p className="text-gray-700 text-sm">
                                Know the cost before we begin. No surprises, no hidden fees. What we quote is what you pay.
                            </p>
                        </div>

                        {/* Feature 3 */}
                        <div className="bg-white rounded-lg p-4 shadow hover:shadow-md transition">
                            <img
                                src="https://electricityplans.com/wp-content/uploads/2021/02/satisfaction-guaranteed-740x415.jpg"
                                alt="Guaranteed Satisfaction"
                                className="w-full h-40 object-cover rounded mb-4" />
                            <h3 className="text-xl font-semibold mb-1">Satisfaction Guaranteed</h3>
                            <p className="text-gray-700 text-sm">
                                Every job is backed by our quality promise. We’re not happy until you are.
                            </p>
                        </div>
                    </div>

                    {/* Details Section */}
                    <div className="mt-16 grid md:grid-cols-2 gap-6 items-center">
                        <div>
                            <h3 className="text-2xl font-semibold mb-3">Reliable Customer Services for Garage</h3>
                            <p className="text-gray-700 text-sm mb-4">
                                MM AutoTech goes beyond repairs — we provide dedicated customer service support to help your garage grow and retain happy clients. Let us handle the conversations while you focus on the cars.
                            </p>
                            <ul className="list-disc pl-5 space-y-1 text-gray-700 text-sm">
                                <li>✔ 24/7 Call Handling & Live Chat Support</li>
                                <li>✔ Appointment Scheduling & Follow-Ups</li>
                                <li>✔ Customer Enquiry & Complaint Management</li>
                                <li>✔ Service Reminders & Loyalty Programs</li>
                                <li>✔ Multi-language Support Available</li>
                            </ul>
                        </div>
                        <img
                            src="https://blog.happyfox.com/wp-content/uploads/2020/10/Customer-Service-Vs-Customer-Support-Vs-Customer-Success.png"
                            alt="Support"
                            className="w-full max-w-md mx-auto rounded" />
                    </div>
                </section>

                {/* ✅ Call to Action Section */}
                <section className="bg-[#f4f6fc] text-black text-center py-12 px-4">
                    <p className="uppercase text-sm font-medium text-gray-700 mb-2">Emergency Call 24/7</p>
                    <p className="text-3xl font-bold text-[#111827] mb-1">+44 7747 762059</p>
                    <div className="w-10 h-1 bg-yellow-400 mx-auto mb-4"></div>
                    <p className="uppercase text-xs font-semibold text-gray-700 mb-5 tracking-widest">
                        Book an appointment today
                    </p>
                    <Link to="/contact">
                        <button className="inline-flex items-center gap-2 bg-[#1f2e9f] text-white px-5 py-2.5 rounded-md font-semibold shadow relative">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                    d="M8 7V3M16 7V3M3 11h18M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            Book Now
                            <span className="absolute right-0 top-1/2 transform -translate-y-1/2 h-full w-1 bg-yellow-400 rounded-r-md"></span>
                        </button>
                    </Link>
                </section>

                {/* ✅ FAQ Section */}
                <FAQSection />
            </div></>
    );
};

export default CustomerServices;
